/** * * Asynchronously loads the component for
PreloadedSimFlow
* */ import { lazyLoad } from "utils/loadable";
export const PreloadedSimFlow = lazyLoad(
  () => import("./index"),
  (module) => module.PreloadedSimFlow,
);
